import React, { Component } from 'react'
import { Spin } from 'antd'
import MyFrame from '../components/Frame'
import { Route, Switch, Redirect } from 'react-router-dom'
import PRanks from "./ranks/PRanks"
import DRanks from "./ranks/DRanks"
import Filter from "./ranks/Filter"
import Players from "./playerInfo/Players"
import TeamEditor from "./ranks/TeamEditor"
import Team from "./ranks/Team"
import ProTeamManage from "./ranks/ProTeamManage"
import { app } from "../app"
import TeamEdit from "./ranks/TeamEdit"
import Staffing from "./ranks/Staffing"
import TeamHonorEdit from "./ranks/TeamHonorEdit"
import TeamAddress from "./ranks/TeamAddress"
import TeamDynamic from "./ranks/TeamMore/TeamDynamic"
import TeamMien from "./ranks/TeamMore/TeamMien"
import TeamMienDetail from "./ranks/TeamMore/TeamMienDetail"
import TeamPublic from "./ranks/TeamMore/TeamPublic"
import TeamPublicDetail from "./ranks/TeamMore/TeamPublicDetail"
import TeamEquipments from "./ranks/TeamMore/TeamEquipments"
import TeamDelEditor from "./ranks/TeamDelEditor"
import CaseAdmin from "./ranks/CaseAdmin"

import '../css/ranks.css'
import SignReport from "./sign/SignReport"
import NewsTeam from "./ranks/NewsTeam"
import api from "../api"
import TMNews from "./ranks/TeamMore/TMNews"
import Province from "./ranks/Province"
import TMPNews from "./ranks/TeamMore/TMPNews"
import HonorWall from "./ranks/HonorWall"
import TeamHonorWall from "./ranks/TeamMore/TeamHonorWall"
import Message from './message/Message'
import TeamApplication from './teamApplication/TeamApplication'

function checkMenu(path) {
    let key = '1'
    switch (path) {
        case '/ranks/filter':
            key = '2'
            break
        case '/ranks/team-editor':
            key = '3'
            break
        case '/ranks/proteam-manage':
            key = '4'
            break
        case '/ranks/staffing':
            key = '5'
            break
        case '/ranks/team-edit':
            key = '6'
            break
        case '/ranks/teamhonor-edit':
            key = '7'
            break
        case '/ranks/team-address':
            key = '8'
            break
        case '/ranks/team-del-editor':
            key = '9'
            break
        case '/ranks/report':
            key = '10'
            break
        case '/ranks/news':
            key = '11'
            break
        case '/ranks/honor-wall':
            key = '12'
            break
        case '/ranks/message':
            key = '13'
            break
        case '/ranks/TeamApplication':
            key = '14'
            break
        case '/ranks/case-admin':
            key = '15'
            break

    }
    return key
}

class Ranks extends Component {
    constructor(props) {
        super(props)
        this.state = {
            rights: app.getData('rights'),
            tab: 1, //标签
            news_audit: 0,
            report_audit: 0,
            menu_key: checkMenu(props.location.pathname),
            loading: true
        }
    };

    /**
     * 获取权限
     * @returns {Promise<void>}
     */
    getAudit = async () => {
        const params = {
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        }
        let { flag, data, msg } = await app.post(api.TeamFeaturesAuthorize, params)
        if (flag === 1) {
            this.setData({ news_audit: data.news, report_audit: data.reports })
        } else {
            app.alert(msg, "error")
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.location.pathname !== nextProps.location.pathname) {
            this.setData({ menu_key: checkMenu(nextProps.location.pathname) })
        }
    }

    /**
     * 设置值
     * @param data
     */
    setData = (data) => app.setStateSync(this, data)


    async componentDidMount() {
        this._isMounted = true
        if (app.getToken()) {
            await this.getAudit()
        }
        await this.setData({ loading: false })
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    render() {
        const { rights, news_audit, report_audit, menu_key, loading } = this.state,
            menuList = [
                { key: '1', text: '队伍列表', link: '/ranks' }
            ],
            nodeList = []
        // console.log('rights: ' + rights)
        if (loading) {
            return (
                <div style={{ textAlign: 'center', padding: '3rem 0' }}>
                    <Spin size="large" tip="正在加载..." />
                </div>
            )
        }
        // if (news_audit === 1) {
        //     menuList.push({ key: '11', text: '新闻管理', link: '/ranks/news' })
        //     nodeList.push(<Route key="8" exact path="/ranks/news" component={NewsTeam} />)
        // }
        // if (report_audit === 1) {
        //     menuList.push({ key: '10', text: '任务管理', link: '/ranks/report' })
        //     nodeList.push(<Route key="9" exact path="/ranks/report" component={SignReport} />)
        // }
        if ("123".indexOf(rights) > -1) {
            menuList.push(
                { key: '4', text: '队员管理', link: '/ranks/proteam-manage' },
                { key: '5', text: '人员调配', link: '/ranks/staffing' },
                { key: '6', text: '队伍编辑', link: '/ranks/team-edit' },
                // { key: '8', text: '队部地址', link: '/ranks/team-address' },
                // { key: '13', text: '短信服务', link: '/ranks/message' },
                // { key: '7', text: '荣誉编码', link: '/ranks/teamhonor-edit' },
                // { key: '12', text: '荣誉墙管理', link: '/ranks/honor-wall' },
            )
            nodeList.push(
                (<Route key="1" exact path="/ranks/staffing" component={Staffing} />),
                (<Route key="2" exact path="/ranks/proteam-manage" component={ProTeamManage} />),
                (<Route key="3" exact path="/ranks/team-edit" component={TeamEdit} />),
                (<Route key="4" exact path="/ranks/teamhonor-edit" component={TeamHonorEdit} />),
                (<Route key="5" exact path="/ranks/team-address" component={TeamAddress} />),
                (<Route key="12" exact path="/ranks/honor-wall" component={HonorWall} />),
                (<Route key="13" exact path="/ranks/message" component={Message} />),

            )

        }
        if ("12".indexOf(rights) > -1) {
            menuList.push(
                { key: '3', text: '队伍调配', link: '/ranks/team-editor' },
                // { key: '9', text: '已注销队伍', link: '/ranks/team-del-editor' },
            )
            nodeList.push(
                (<Route key="6" exact path="/ranks/team-editor" component={TeamEditor} />),
                // (<Route key="7" exact path="/ranks/team-del-editor" component={TeamDelEditor} />),
            )
        }
        // menuList.push(
        //     { key: '14', text: '队伍申请', link: '/ranks/TeamApplication' },
        //     { key: '2', text: '技能筛选', link: '/ranks/filter' },
        // )
        // if ("1".indexOf(rights) > -1) {
        //     menuList.push(
        //         { key: '15', text: '案件管理', link: '/ranks/case-admin' },
        //     )
        //     nodeList.push(
        //         (<Route key="15" exact path="/ranks/case-admin" component={CaseAdmin} />)
        //     )
        // }
        return (
            <MyFrame className="ranks" history={this.props.history} menuList={menuList} menuSelectKey={menu_key}
                siderWidth="10rem">
                <Switch>
                    <Route exact path="/ranks/players/:teamno" component={Players} />
                    <Route exact path="/ranks/team/:teamno" component={Team} />
                    <Route exact path="/ranks/province/:province" component={Province} />
                    <Route exact path="/ranks/dynamic/:teamno" component={TeamDynamic} />
                    <Route exact path="/ranks/mien/detail/:id" component={TeamMienDetail} />
                    <Route exact path="/ranks/mien/:teamno" component={TeamMien} />
                    <Route exact path="/ranks/equipments/:teamno" component={TeamEquipments} />
                    <Route exact path="/ranks/public/:teamno" component={TeamPublic} />
                    <Route exact path="/ranks/public/detail/:id" component={TeamPublicDetail} />
                    <Route exact path="/ranks/teamnews/:teamno" component={TMNews} />
                    <Route exact path="/ranks/pnews/:province" component={TMPNews} />
                    <Route exact path="/ranks/honorwall/:teamno" render={(props) => {
                        return (<TeamHonorWall onBack={() => app.backPage(this)} enter="team" param={props.match.params.teamno} />)
                    }} />
                    <Route exact path="/ranks/phonorwall/:province" render={(props) => {
                        return (<TeamHonorWall onBack={() => app.backPage(this)} enter="province" param={props.match.params.province} />)
                    }} />
                    <Route exact path="/ranks/filter" component={Filter} />
                    <Route exact path="/ranks/TeamApplication" component={TeamApplication} count={12} />

                    {nodeList}
                    {/*<Route exact path="/ranks/pro/:province" component={DRanks} />*/}
                    <Route exact path="/ranks" component={DRanks} />
                    <Route render={() => <Redirect to="/ranks" />} />
                </Switch>
            </MyFrame>
        )
    }
}

export default Ranks



// WEBPACK FOOTER //
// ./src/routes/Ranks.jsx